<template>
  <v-menu location="end" rounded="lg" :close-on-content-click="false">
    <template #activator="{ props }">
      <v-card v-bind="props" color="rgb(0 0 0 / 5%)"
        class="pa-3 d-flex flex-column justify-center align-center account-button-trigger" variant="flat" rounded="0">
        <Avatar :fullname="userInfo.Name" color="red" class="mb-1" />
        {{ $t('text.account') }}
      </v-card>
    </template>

    <v-card class="account-menu-card" elevation="8" min-width="280" max-width="320" rounded="lg">
      <div class="account-menu-card__avatar pa-4 text-center">
        <Avatar :fullname="userInfo.Name" color="red" :large="true" />
      </div>

      <div class="account-menu-card__fields px-4 pb-1">
        <div class="mb-3">
          <div class="text-medium-emphasis">{{ $t('text.username') }}</div>
          <div class="text-break">{{ userInfo.Name }}</div>
        </div>
        <div class="mb-1">
          <div class="text-medium-emphasis">{{ $t('text.email') }}</div>
          <div class="text-break">{{ userInfo.Email }}</div>
        </div>
      </div>

      <div class="d-flex justify-center px-4 py-4">
        <LanguageSelector />
      </div>

      <v-divider />

      <HoverListItem color="error" icon="mdi-logout-variant" :text="$t('text.logout')" @click="logoutUser()" />
    </v-card>
  </v-menu>
</template>

<script>
import Avatar from "@/components/Cards/Avatar.vue";
import AuthStoreMixin from "@/helpers/mixins/AuthStoreMixin";
import HoverListItem from "@/components/ListItems/HoverListItem.vue";
import LanguageSelector from "@/components/Inputs/LanguageSelector.vue";

export default {
  name: "AccountButton",
  props: {},
  mixins: [AuthStoreMixin],
  components: {
    Avatar,
    HoverListItem,
    LanguageSelector,
  },

  computed: {
    userInfo() {
      return this.authUserInfo ?? { Name: "", Email: "" };
    },
  },
};
</script>

<style scoped>
.account-button-trigger {
  width: 100%;
  cursor: pointer;
}

.account-menu-card {
  overflow: hidden;
}

.account-menu-card__avatar :deep(.v-avatar) {
  margin-inline: auto;
}

.account-menu-card__fields {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  padding-top: 12px;
}
</style>
